import axios, { AxiosResponse } from "axios";
import { ApiError } from "../ApiError";
import apis from "../apis";

export class CreateEndpoint implements ICreateEndpoint
{
    public async execute(buildingId: number,cateringMenuItemId: string, payload: ICreateCateringRestrictionsPayload): Promise<void>
    {
        try
        {
            await axios.post(`${apis.allApiv2}${buildingId}/catering-menuitem/${cateringMenuItemId}/catering-restrictions`, payload);
        }
        catch (response)
        {
            throw ApiError.fromAxiosResponse(response as AxiosResponse);
        }
    }
}

export interface ICreateEndpoint
{
    execute(buildingId: number,cateringMenuItemId:string, payload: ICreateCateringRestrictionsPayload): Promise<void>;
}

export interface ICreateCateringRestrictionsPayload
{
    Add_Ids: string[];
    Remove_Ids: string[]
}